const playerValue = (payload: Record<string, unknown>, key: string): string =>
	payload[key] == null ? '' : String(payload[key]);

export const registrationNotificationUrl = (
	template: string,
	payload: Record<string, unknown>,
): string => {
	let url = template;
	for (const key of ['firstName', 'lastName', 'email']) {
		const value = playerValue(payload, key);
		url = url.replaceAll(`\${${key}}`, value).replaceAll(`\${ ${key} }`, value);
	}
	return url;
};

export const fireRegistrationNotification = (
	template: string,
	payload: Record<string, unknown>,
): void => {
	const url = registrationNotificationUrl(template, payload);
	void fetch(url, { method: 'GET', mode: 'no-cors' }).catch(() => undefined);
};
